import { Typography } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import StudentInterviewModuleCard from '../../Components/ApplicationCard/StudentInterviewModuleCard';
import ApplicationCard from '../../Components/ApplicationCard';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { AuthContext } from '../../Context/authContext';
import { getApplicationByApplicationId, getApplicationsByApplicantId, getAllPrograms } from '../../Utils/apiServices';
import { useQuery } from '@tanstack/react-query';
import KenLoader from '../../Components/KenLoader';

const useStyles = makeStyles((theme) => ({
    customCardWidth: {
        width: "300px",   /* set your custom width */
        // "max-width": "100%", /* prevents overflow on small screens */
        "margin": "0 auto",
        "float": "left"
    },
    courseBoxContainer: {
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: '0.5rem',
        padding: '1.25rem',
        height: '100%',
        boxSizing: 'border-box',
        overflow: 'hidden',
        scrollbarWidth: 'thin',
        scrollbarColor: '#ccc transparent',
        '&::-webkit-scrollbar': {
          width: '4px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#bbb',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-button': {
          display: 'none',
        },
        [theme.breakpoints.down('md')]: {
          height: 'auto',
          background: 'none !important',
          padding: '0px',
        },
        '@media (max-width: 1440px)': {
          padding: '1rem',
        },
      },
}));

const StudentInterviewModule = () => {
    const navigate = useNavigate();
    const classes = useStyles({});
    const {state: {user}} = useContext(AuthContext);

    const { data = {}, isLoading, isFetching  } = useQuery({
      queryKey: ['programs-applications', user?.applicantId],
      queryFn: async () => {
        const [programs, applications] = await Promise.all([getAllPrograms(user?.applicantId), getApplicationsByApplicantId(user?.applicantId)]);
        return { programs, applications };
      },
      enabled: !!user?.applicantId,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
    });

    console.log(data.applications?.data, data.programs?.data, "applications")
    
    // 🔹 Merge Applications with Forms
  const mergedItems = (data?.applications?.data || []).map(app => {
    const form = (data?.programs?.data?.forms || []).find(
      f => f.recordId === app.Application_Form__c
    );

    return {
      // From forms
      applicationFormName: form?.applicationFormName,
      programName: form?.programName,
      programNameShort: form?.programNameShort,
      startDate: form?.startDate,
      endDate: form?.endDate,
      endDateStage2: form?.endDateStage2,
      paymentSubmissionDate: form?.paymentSubmissionDate,
      academicCycle: form?.academicCycle,

      // From applications
      Application_Number__c: app.Application_Number__c,
      hed__Application_Status__c: app.hed__Application_Status__c,
      Current_Step__c: app.Current_Step__c,
      Id: app.Id,

      // Optional fallbacks
      Awaited_Submission_Steps__c: "",
      Sub_Status__c: "",
    };
  });

  // Example: Just take the first merged item for now
  const item = mergedItems[0];

  console.log(item, "item")

    // const item = {
    //     // Title shown at the top
    //     applicationFormName: "MBA in Global Supply Chain Management (GSCM)",
    
    //     // Shows as: "Application Number: #2026"
    //     Application_Number__c: "2026",
    
    //     // Used to pick the banner image (maps via `programs.find(...)`)
    //     programName: "MBA in Global Supply Chain Management (GSCM)",
    //     programNameShort: "MBA", // keep if your `programs` list checks this
    
    //     // Keep status undefined to hit Scenario 1 (not initiated) and show last date + CTA
    //     // hed__Application_Status__c: undefined,
    
    //     // Controls whether the card says “Opening on”, “Last Date to Apply”, or “Closed”
    //     // NOTE: format must be 'YYYY-MM-DD hh:mm:ss'
    //     startDate: "2025-03-01 09:00:00", // already opened (in the past)
    //     endDate:   "2025-09-23 23:59:00", // future => shows the last date row
    
    //     // Extras used elsewhere in the component (safe defaults)
    //     Current_Step__c: "0",
    //     paymentSubmissionDate: "2025-03-25 23:59:00",
    //     academicCycle: "2025-26",
    //     Awaited_Submission_Steps__c: "",
    //     Sub_Status__c: "", // for EMBA flow
    //     endDateStage2: "2025-04-15 23:59:00",
    //     Id: "app-2026",
    // };

    // 🔹 Button handlers the card calls
    const goToApplicationForm = (appItem) => {
        // route to your interview booking / application form
        navigate("/app/student/slot-booking", { state: { applicationId: appItem.Id } });
    };

    return (
      <>
        {(isLoading || isFetching) && <KenLoader />}
        <div className={classes.courseBoxContainer}>
            <Typography style={{fontSize:'1rem',marginBottom:'1rem'}}>
                Interviews available to book a slot
            </Typography>
            <div className={classes.customCardWidth}>
                <ApplicationCard
                  item={item}
                  goToApplicationForm={goToApplicationForm}
                  home={false}
                />
            </div>
        </div>
      </>
    );
};

export default StudentInterviewModule;